// import NeedHelpButton from '@/components/NeedHelpButton.vue'

export const steps = {
  config: {
    name: 'config',
    link: 'https://www.youtube.com/embed/0hFFFD7hc7c',
    route: 'config',
    description: 'tutorial for Products'
  },
  lastProducts: {
    name: 'lastProducts',
    link: 'https://www.youtube.com/embed/uKwIOwfLLGg',
    route: 'lastProducts'
  },
  billing: {
    name: 'billing',
    link: 'https://www.youtube.com/embed/3PfmVNOxVMA',
    route: 'billing'
  },
  bookings: {
    name: 'bookings',
    link: 'https://www.youtube.com/embed/aGfxg1SVoo8',
    route: 'bookingsManager'
  },
  bookingsConfig: {
    name: 'bookingsConfig',
    link: 'https://www.youtube.com/embed/Hi77tK8I_gg',
    route: 'bookingsConfig'
  },
  virtualBrands: {
    name: 'virtualBrands',
    link: 'https://www.youtube.com/embed/umm_mBDoOjU',
    route: 'virtualBrands'
  },
  schedules: {
    name: 'schedules',
    link: ' https://www.youtube.com/embed/R4kapWASgho',
    route: 'schedules'
  },
  shop: {
    name: 'shop',
    link: 'https://www.youtube.com/embed/_rgkW8UWj0U',
    route: 'locationShop'
  },
  delivery: {
    name: 'delivery',
    link: 'https://www.youtube.com/embed/fTHVHu57WbE',
    route: 'delivery'
  },
  catalogs: {
    name: 'catalogs',
    link: 'https://www.youtube.com/embed/7YZs_BMjMHw',
    route: 'catalogs'
  },
  catalogAssignation: {
    name: 'catalogAssignation',
    link: 'https://www.youtube.com/embed/38XVqS8pPCk',
    route: 'locationBrandCatalogs'
  },
  promotions: {
    name: 'promotions',
    link: 'https://www.youtube.com/embed/3XkNGxBFork',
    route: 'promotions'
  },
  users: {
    name: 'users',
    link: 'https://www.youtube.com/embed/ktSSebF_D40',
    route: 'users'
  },
  devices: {
    name: 'devices',
    link: 'https://survey.last.app/zs/bFBjIE',
    route: 'devices'
  },
  floorPlan: {
    name: 'floorPlan',
    link: 'https://www.youtube.com/embed/TrLMwRZBYzw',
    route: 'floorPlan'
  },
  employees: {
    name: 'employees',
    link: 'https://www.youtube.com/embed/_5NflwIwhEI',
    route: 'employees'
  },
  integrations: {
    name: 'integrations',
    link: 'https://www.youtube.com/embed/2Abxily6aio',
    route: 'integrations'
  }
}

export const flows = {
  bookings: [
    'config',
    'virtualBrands',
    'schedules',
    'shop',
    'delivery',
    'catalogs',
    'promotions',
    'users',
    'devices'
  ],
  hub: ['config', 'virtualBrands', 'schedules', 'delivery', 'catalogs', 'users', 'devices'],
  shop: [
    'config',
    'virtualBrands',
    'schedules',
    'shop',
    'delivery',
    'catalogs',
    'promotions',
    'users',
    'devices'
  ],
  pos: [
    'config',
    'virtualBrands',
    'employees',
    'floorPlan',
    'schedules',
    'catalogs',
    'promotions',
    'users',
    'devices'
  ]
}

export default { steps, flows }
